import React from 'react'

import buddy from './assets/buddy.png'
import catball from './assets/catball.png'
import felix from './assets/felix.png'
import genesy from './assets/genesy.png'
import hybridge from './assets/hybridge.png'
import hyperbeat from './assets/hyperbeat.png'
import hyperdrive from './assets/hyperdrive.png'
import hyperflash from './assets/hyperflash.png'
import hyperfly from './assets/hyperfly.png'
import hyperlend from './assets/hyperlend.png'
import hyperstable from './assets/hyperstable.png'
import hypio from './assets/hypio.png'
import hypurrco from './assets/hypurrco.png'
import hypurrfi from './assets/hypurrfi.png'
import jeff from './assets/jeff.png'
import keiko from './assets/keiko.png'
import kinetiq from './assets/kinetiq.png'
import liquidlaunch from './assets/liquidlaunch.png'
import loopedhype from './assets/loopedhype.png'
import pip from './assets/pip.png'
import thunderhead from './assets/thunderhead.png'
import timeswap from './assets/timeswap.png'
import unit from './assets/unit.png'
import vortx from './assets/vortx.png'

export interface EcosystemItem {
  name: string
  logo: JSX.Element
  url?: string
  disabled?: boolean
  description?: React.ReactNode
}

interface Ecosystem {
  [key: string]: EcosystemItem
}
export const ecosystemList: Ecosystem = {
  BUDDY: {
    name: 'Buddy',
    logo: <img src={buddy} alt="buddy" />,
    url: 'https://linktr.ee/alrightbuddy',
    description: (
      <span>
        Hold 10,000 <b>BUDDY</b> & use HyperSwap.
      </span>
    ),
  },
  CATBALL: {
    name: 'Catball',
    logo: <img src={catball} alt="catball" />,
    url: 'https://x.com/CatCabal_hl',
    description: (
      <span>
        Hold 70 <b>Catball</b> & use HyperSwap.
      </span>
    ),
  },
  FELIX: {
    name: 'Felix',
    logo: <img src={felix} alt="felix" />,
    url: 'https://usefelix.xyz/',
    description: (
      <span>
        Borrow <b>feUSD</b> on Felix & provide liquidity on HyperSwap.
      </span>
    ),
  },
  GENESY: {
    name: 'Genesy',
    logo: <img src={genesy} alt="genesy" />,
    url: 'https://app.genesy.fun/',
    description: <span>Provide liquidity on the project’s token pool.</span>,
  },
  HYBRIDGE: {
    name: 'Hybridge',
    logo: <img src={hybridge} alt="hybridge" />,
    url: 'https://v3.hybridge.xyz/',
    disabled: true,
  },
  HYPERBEAT: {
    name: 'Hyperbeat',
    logo: <img src={hyperbeat} alt="hyperbeat" />,
    url: 'https://app.hyperbeat.org/',
    disabled: true,
  },
  HYPERDRIVE: {
    name: 'Hyperdrive',
    logo: <img src={hyperdrive} alt="hyperdrive" />,
    url: 'https://hyperdrive.fi/',
    disabled: true,
  },
  HYPERFLASH: {
    name: 'Hyperflash',
    logo: <img src={hyperflash} alt="hyperflash" />,
    url: 'https://hyperflash.xyz/',
    disabled: true,
  },
  HYPERFLY: {
    name: 'Hyperfly',
    logo: <img src={hyperfly} alt="hyperfly" />,
    url: 'https://hyperfly.sh/',
    description: <span>Provide liquidity on the project’s token pool.</span>,
  },
  HYPERLEND: {
    name: 'HyperLend',
    logo: <img src={hyperlend} alt="hyperlend" />,
    url: 'https://hyperlend.finance/',
    description: <span>Deposit on HyperLend & use HyperSwap.</span>,
  },
  HYPERSTABLE: {
    name: 'HyperStable',
    logo: <img src={hyperstable} alt="hyperstable" />,
    url: 'https://www.hyperstable.xyz/',
    disabled: true,
  },
  HYPIO: {
    name: 'Hypio',
    logo: <img src={hypio} alt="hypio" />,
    url: 'https://linktr.ee/hypio',
    description: (
      <span>
        Hold 2 <b>Hypio NFTs</b> or 1 <b>HyperSwapio (HyperSwap trait)</b> & use HyperSwap.
      </span>
    ),
  },
  HYPURRCO: {
    name: 'HypurrCo',
    logo: <img src={hypurrco} alt="hypurrco" />,
    url: 'https://bento.me/hypurrco',
    description: (
      <span>
        Stake 50 <b>HYPE</b> with Hypurrco & use HyperSwap.
      </span>
    ),
  },
  HYPURRFI: {
    name: 'HypurrFi',
    logo: <img src={hypurrfi} alt="hypurrfi" />,
    url: 'https://www.hypurr.fi/',
    description: (
      <span>
        Borrow <b>USDXL</b> on HypurrFi & provide liquidity on HyperSwap.
      </span>
    ),
  },
  JEFF: {
    name: 'Jeff',
    logo: <img src={jeff} alt="jeff" />,
    disabled: true,
  },
  KEIKO: {
    name: 'Keiko',
    logo: <img src={keiko} alt="keiko" />,
    url: 'https://keikofinance.com/',
    description: (
      <span>
        Borrow <b>KEI</b> & provide liquidity on HyperSwap.
      </span>
    ),
  },
  KINETIQ: {
    name: 'Kinetiq',
    logo: <img src={kinetiq} alt="kinetiq" />,
    url: 'https://kinetiq.xyz/',
    disabled: true,
  },
  LIQUIDLAUNCH: {
    name: 'LiquidLaunch',
    logo: <img src={liquidlaunch} alt="liquidlaunch" />,
    url: 'https://liquidlaunch.app/',
    description: <span>Hold tokens until bonding on HyperSwap.</span>,
  },
  LOOPEDHYPE: {
    name: 'LoopedHype',
    logo: <img src={loopedhype} alt="loopedhype" />,
    url: 'https://loopedhype.com/',
    description: (
      <span>
        Stake <b>HYPE</b>, receive <b>LHYPE</b>, & provide liquidity on HyperSwap.
      </span>
    ),
  },
  PIP: {
    name: 'Pip',
    logo: <img src={pip} alt="pip" />,
    url: 'https://linktr.ee/piponhl',
    description: (
      <span>
        Hold 70 <b>PiP</b> & use HyperSwap.
      </span>
    ),
  },
  THUNDERHEAD: {
    name: 'Thunderhead',
    logo: <img src={thunderhead} alt="thunderhead" />,
    url: 'https://thunderhead.xyz/',
    description: (
      <span>
        Stake <b>HYPE</b>, receive <b>stHYPE</b>, & provide liquidity on HyperSwap.
      </span>
    ),
  },
  TIMESWAP: {
    name: 'TimeSwap',
    logo: <img src={timeswap} alt="timeswap" />,
    url: 'https://app.timeswap.io/',
    description: (
      <span>
        Deposit <b>HYPE</b> & use the LP token as collateral.
      </span>
    ),
    disabled: true,
  },
  UNIT: {
    name: 'Unit',
    logo: <img src={unit} alt="unit" />,
    url: 'https://hyperunit.xyz/',
    description: (
      <span>
        Provide liquidity in <b>uBTC / uETH</b> pools.
      </span>
    ),
  },
  VORTX: {
    name: 'VortX',
    logo: <img src={vortx} alt="vortx" />,
    url: 'https://www.vortx.gg/',
    description: <span>Use HyperSwap with Vortex.</span>,
    disabled: true,
  },
}
